import React, { useState } from 'react';
import './EnvoyerMailAdmin.css';
import DashboardHeader from '../../components/DashboardHeader';
import AdminNavigationBar from '../../components/AdminNavigationBar';

function EnvoyerMailAdmin() {
  const [selectedRecipients, setSelectedRecipients] = useState([]);
  const [message, setMessage] = useState('');
  const [attachments, setAttachments] = useState([
    { id: 1, name: 'Document.pdf', type: 'pdf' }
  ]);

  const availableRecipients = [
    { id: 1, name: 'Marvin McKI', avatar: '👨' },
    { id: 2, name: 'Shud_erma', avatar: '👤' },
    { id: 3, name: 'Devon Lane', avatar: '👩' }
  ];

  const toggleRecipient = (recipient) => {
    if (selectedRecipients.find(r => r.id === recipient.id)) {
      setSelectedRecipients(selectedRecipients.filter(r => r.id !== recipient.id));
    } else {
      setSelectedRecipients([...selectedRecipients, recipient]);
    }
  };

  const removeAttachment = (id) => {
    setAttachments(attachments.filter(att => att.id !== id));
  };

  const handleSendMail = (e) => {
    e.preventDefault();
    console.log('Sending mail to:', selectedRecipients);
    console.log('Message:', message);
    console.log('Attachments:', attachments);
  };

  return (
    <div className="admin-layout">
      <DashboardHeader />
      <AdminNavigationBar 
        title="Envoyer un Mail" 
        onBack={() => window.navigateTo && window.navigateTo('admin-dashboard')}
      />
      <div className="admin-container">
        <main className="admin-content admin-content-full">
          <div className="admin-mail-content">
            {/* Stats Cards */}
            <div className="stats-grid">
              <div className="stat-card">
                <div className="stat-header">
                  <span className="stat-title">Historique des Mails</span>
                </div>
                <div className="stat-value">300</div>
                <div className="stat-label">mails envoyés</div>
              </div>

              <div className="stat-card">
                <div className="stat-header">
                  <span className="stat-title">Aujourd'hui</span>
                </div>
                <div className="stat-value">40</div>
                <div className="stat-label">Mail reçu</div>
              </div>

              <div className="stat-card">
                <div className="stat-header">
                  <span className="stat-title">Non lus</span>
                </div>
                <div className="stat-value">07</div>
                <div className="stat-label">Mails non lus</div>
              </div>

              <div className="stat-card">
                <div className="stat-header">
                  <span className="stat-title">Brouillons</span>
                </div>
                <div className="stat-value">14</div>
                <div className="stat-label">Mails non envoyés</div>
              </div>
            </div>

            {/* Mail Form Card */}
            <div className="mail-form-card">
              <div className="mail-form-header">
                <h2>Nouveau Mail</h2>
                <button className="close-btn">✕</button>
              </div>

              <form onSubmit={handleSendMail}>
                {/* From Section */}
                <div className="form-field">
                  <label className="field-label">De</label>
                  <div className="sender-info">
                    <div className="sender-avatar">AS</div>
                    <span className="sender-name">Anna_Shud</span>
                    <span className="sender-email">(moi)</span>
                    <span className="dropdown-icon">▾</span>
                  </div>
                </div>

                {/* To Section */}
                <div className="form-field">
                  <label className="field-label">À</label>
                  <div className="recipients-section">
                    {availableRecipients.map((recipient) => (
                      <div
                        key={recipient.id}
                        className={`recipient-chip ${selectedRecipients.find(r => r.id === recipient.id) ? 'selected' : ''}`}
                        onClick={() => toggleRecipient(recipient)}
                      >
                        <div className="recipient-avatar">{recipient.avatar}</div>
                        <span className="recipient-name">{recipient.name}</span>
                        <span className="recipient-badge">🔒</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Message Section */}
                <div className="form-field">
                  <label className="field-label">Message</label>
                  <textarea
                    className="message-textarea"
                    placeholder="Bonjour, j'espère que ....."
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    rows="8"
                  />
                </div>

                {/* Attachment Section */}
                <div className="form-field">
                  <label className="field-label">Attachement</label>
                  <div className="attachments-list">
                    {attachments.map((attachment) => (
                      <div key={attachment.id} className="attachment-item">
                        <div className="attachment-icon">📄</div>
                        <span className="attachment-name">{attachment.name}</span>
                        <button
                          type="button"
                          className="remove-attachment-btn"
                          onClick={() => removeAttachment(attachment.id)}
                        >
                          🗑
                        </button>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="form-actions">
                  <div className="action-icons">
                    <button type="button" className="action-icon-btn" title="Ajouter une pièce jointe">
                      📎
                    </button>
                    <button type="button" className="action-icon-btn" title="Insérer une image">
                      🖼
                    </button>
                    <button type="button" className="action-icon-btn" title="Insérer un lien">
                      🔗
                    </button>
                    <button type="button" className="action-icon-btn" title="Emoji">
                      😊
                    </button>
                    <button type="button" className="action-icon-btn" title="Plus d'options">
                      ⋯
                    </button>
                  </div>

                  <button type="submit" className="send-btn">
                    Envoyer
                  </button>
                </div>
              </form>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default EnvoyerMailAdmin;
